"use client";
import dynamic from "next/dynamic";
import "../../src/common/grid.css";
import styles from "./home-page.module.css";
import Image from "next/image";
import aboutImage from "../../src/assets/images/clarkAbout.webp";
import awar1 from "../../src/assets/images/awar1.png";
import awar2 from "../../src/assets/images/awar2.png";
import awar3 from "../../src/assets/images/awar3.png";
import ourLendersImage1 from "../../src/assets/images/our-lenders-first-image.webp";
import ourLendersImage2 from "../../src/assets/images/our-lenders-second-image.webp";
import leftScrollArrow from "../../src/assets/icons/leftScrollArrow.svg";
import rightScrollArrow from "../../src/assets/icons/rightScrollArrow.svg";
import blogImage1 from "../../src/assets/images/demystifyingBusinessFinanceImage.webp";
import blogImage2 from "../../src/assets/images/comprehensiveLoanApplicationImage.webp";
import { useState, useEffect, useRef } from "react";
import keyIconBlue from "../../src/assets/icons/Key--Streamline-Iconoir.svg";
import loopBlue from "../../src/assets/icons/loopBlue.svg";
import groupBlue from "../../src/assets/icons/groupBlue.svg";
import circle1 from "../../src/assets/icons/circle1.svg";
import circle2 from "../../src/assets/icons/circle2.svg";
import circle3 from "../../src/assets/icons/circle3.svg";
import circle4 from "../../src/assets/icons/circle4.svg";
import building from "../../src/assets/icons/Group.svg";
import CalendarIconWhite from "../../src/assets/icons/calendarIconWhite.svg";
import calendar from "../../src/assets/icons/Calendar1.svg";
import { useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import ChatIcon from "../../src/assets/icons/chatIcon.svg";
import RepaymentWidget from "../RepaymentWidget/RepaymentWidget";
import BookDemoPopup from "../BookDemoPopup/BookDemoPopup";
const ReachOutSection = dynamic(() =>
  import("../reachOutCommonSection/reachOutSection")
);
const TestimonialCarousel = dynamic(() =>
  import("../TestimonialCarousel/TestimonialCarousel")
);
import { submitLoanForm } from "@/services/api";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const HomePage = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(1);
  const [isAnimating, setIsAnimating] = useState(false);
  const [selectedLoanType, setSelectedLoanType] = useState(null);
  const [sliderValue, setSliderValue] = useState(100000);
  const [currentStep, setCurrentStep] = useState(1);
  const [loanPurpose, setLoanPurpose] = useState(null);
  const [loanDetails, setLoanDetails] = useState({
    amount: 100000,
    term: 1,
  });
  const [carLoanUsage, setCarLoanUsage] = useState(null);
  const originalImages = [ourLendersImage1, ourLendersImage2];
  const totalSlides = originalImages.length;
  const [counterStarted, setCounterStarted] = useState(false);
  const [happyClients, setHappyClients] = useState(0);
  const [loanValue, setLoanValue] = useState(0);
  const trackRecordRef = useRef(null);
  const aboutBannerRef = useRef(null);
  const loanSectionRef = useRef(null);
  const [autoSlideInterval, setAutoSlideInterval] = useState(null);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [propertyUsage, setPropertyUsage] = useState(null);
  const [fullName, setFullName] = useState("");
  const [nameError, setNameError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [depositValue, setDepositValue] = useState(10000);
  const [depositType, setDepositType] = useState("amount");
  const [depositPercentage, setDepositPercentage] = useState(20);
  const howWeHelpRef = useRef(null);
  const [isHowWeHelpVisible, setIsHowWeHelpVisible] = useState(false);
  const [isHowWeWorkVisible, setIsHowWeWorkVisible] = useState(false);
  const howWeWorkRef = useRef(null);
  const handleCardClick = (route) => {
    router.push(route);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (
      currentStep === 2 &&
      ["car", "equipment", "personal", "business"].includes(selectedLoanType)
    ) {
      if (selectedLoanType === "car") {
        setSliderValue(loanDetails.amount);
      } else {
        setSliderValue(loanDetails.term);
      }
    }
  }, [currentStep, selectedLoanType, loanDetails]);

  useEffect(() => {
    if (selectedLoanType === "home" || selectedLoanType === "smsf") {
      if (loanPurpose === "new" && currentStep === 3) {
        if (depositType === "amount") {
          setSliderValue(depositValue);
        } else {
          setSliderValue(depositPercentage);
        }
      }
    }
  }, [
    depositType,
    selectedLoanType,
    loanPurpose,
    currentStep,
    depositValue,
    depositPercentage,
  ]);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };

    const handleIntersect = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !counterStarted) {
          setCounterStarted(true);
          startCounters();
        }
      });
    };
    const observer = new IntersectionObserver(handleIntersect, options);

    if (trackRecordRef.current) {
      observer.observe(trackRecordRef.current);
    }
    if (aboutBannerRef.current) {
      observer.observe(aboutBannerRef.current);
    }

    return () => {
      if (trackRecordRef.current) {
        observer.unobserve(trackRecordRef.current);
      }
      if (aboutBannerRef.current) {
        observer.unobserve(aboutBannerRef.current);
      }
    };
  }, [counterStarted]);
  useEffect(() => {
    startAutoSlide();
    return () => {
      if (autoSlideInterval) {
        clearInterval(autoSlideInterval);
      }
    };
  }, [currentSlide, isAnimating]);
  useEffect(() => {
    const textLines = document.querySelectorAll(
      `.${styles.homepageBannerTitle}`
    );
    let currentIndex = 0;

    function showNextLine() {
      if (currentIndex > 0) {
        textLines[currentIndex - 1].classList.remove(styles.show);
      }

      if (currentIndex < textLines.length) {
        textLines[currentIndex].classList.add(styles.show);
        currentIndex++;
        if (currentIndex < textLines.length) {
          setTimeout(showNextLine, 2000);
        }
      }
    }
    showNextLine();
  }, []);
  const startCounters = () => {
    const happyClientsTarget = 3000;
    const happyClientsStep = Math.ceil(happyClientsTarget / 50);
    const happyClientsDelay = 30;

    let currentHappyClients = 0;
    const happyClientsInterval = setInterval(() => {
      currentHappyClients += happyClientsStep;
      if (currentHappyClients >= happyClientsTarget) {
        setHappyClients(happyClientsTarget);
        clearInterval(happyClientsInterval);
      } else {
        setHappyClients(currentHappyClients);
      }
    }, happyClientsDelay);
    const loanValueTarget = 1;
    const loanValueStep = 0.05;
    const loanValueDelay = 50;
    let currentLoanValue = 0;
    const loanValueInterval = setInterval(() => {
      currentLoanValue += loanValueStep;
      if (currentLoanValue >= loanValueTarget) {
        setLoanValue(loanValueTarget);
        clearInterval(loanValueInterval);
      } else {
        setLoanValue(parseFloat(currentLoanValue.toFixed(2)));
      }
    }, loanValueDelay);
  };
  const startAutoSlide = () => {
    if (autoSlideInterval) {
      clearInterval(autoSlideInterval);
    }
    const interval = setInterval(() => {
      if (isAnimating) return;
      setIsAnimating(true);
      const newPosition = currentSlide + 1;
      setCurrentSlide(newPosition);
      setActiveImageIndex(newPosition % totalSlides);
      setTimeout(() => {
        setIsAnimating(false);
        if (newPosition >= totalSlides * 2) {
          setCurrentSlide(newPosition - totalSlides);
          setActiveImageIndex((newPosition - totalSlides) % totalSlides);
        } else if (newPosition < totalSlides) {
          setCurrentSlide(newPosition + totalSlides);
          setActiveImageIndex((newPosition + totalSlides) % totalSlides);
        }
      }, 500);
    }, 3000);
    setAutoSlideInterval(interval);
  };
  const stopAutoSlide = () => {
    if (autoSlideInterval) {
      clearInterval(autoSlideInterval);
      setAutoSlideInterval(null);
    }
  };
  const handleManualSlide = (direction) => {
    stopAutoSlide();
    if (isAnimating) return;
    setIsAnimating(true);
    const newPosition =
      direction === "next" ? currentSlide + 1 : currentSlide - 1;
    setCurrentSlide(newPosition);
    setActiveImageIndex(newPosition % totalSlides);
    setTimeout(() => {
      setIsAnimating(false);
      if (newPosition >= totalSlides * 2) {
        setCurrentSlide(newPosition - totalSlides);
        setActiveImageIndex((newPosition - totalSlides) % totalSlides);
      } else if (newPosition < totalSlides) {
        setCurrentSlide(newPosition + totalSlides);
        setActiveImageIndex((newPosition + totalSlides) % totalSlides);
      }
    }, 500);
  };

  const renderLendersSection = () => (
    <div className={styles.ourLendersSection}>
      <div className="container">
        <div className={styles.ourLendersContentWrapper}>
          <h2 className={styles.ourLendersTitle}>{t("Our Lenders")}</h2>
          <p className={styles.ourLendersDescription}>
            {t(
              "We offer you access to a network of over 70+ lenders featuring various options and specialized policies, extending beyond the 'big four' banks."
            )}
          </p>
          <div className={styles.ourLendersImageWrapper}>
            <div
              className={styles.ourLendersImagesContainer}
              style={{
                transform: `translateX(-${currentSlide * 100}%)`,
                transition: isAnimating ? "transform 0.5s ease-in-out" : "none",
              }}
            >
              {[...originalImages, ...originalImages, ...originalImages].map(
                (image, index) => (
                  <div key={index} className={styles.slideItem}>
                    <Image
                      className={styles.ourLendersImage}
                      src={image}
                      alt={`ourLendersImage${(index % totalSlides) + 1}`}
                      loading="eager"
                      aria-hidden="false"
                      role="img"
                    />
                  </div>
                )
              )}
            </div>
            <Image
              className={styles.ourLendersScrollLeftArrow}
              src={leftScrollArrow}
              alt="leftScrollArrow"
              loading="eager"
              aria-hidden="false"
              role="img"
              onClick={() => handleManualSlide("prev")}
            />
            <Image
              className={styles.ourLendersScrollRightArrow}
              src={rightScrollArrow}
              alt="rightScrollArrow"
              loading="eager"
              aria-hidden="false"
              role="img"
              onClick={() => handleManualSlide("next")}
            />
          </div>
          {/* <div className={styles.ourLendersCircleControlers}>
            <div
              className={`${styles.ourLendersLeftCircleControler} ${activeImageIndex === 0 ? styles.activeCircle : ""
                }`}
              onClick={() => handleManualSlide("prev")}
              role="button"
              tabIndex={0}
              aria-label={t("Previous slide")}
            ></div>
            <div
              className={`${styles.ourLendersRightCircleControler} ${activeImageIndex === 1 ? styles.activeCircle : ""
                }`}
              onClick={() => handleManualSlide("next")}
              role="button"
              tabIndex={0}
              aria-label={t("Next slide")}
            ></div>
          </div> */}
        </div>
      </div>
    </div>
  );

  const handleWantToRefinaceClick = () => {
    router.push("/want-to-refinance");
  };

  const handleAboutClick = () => {
    router.push("/about");
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsHowWeHelpVisible(true);
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    if (howWeHelpRef.current) {
      observer.observe(howWeHelpRef.current);
    }

    return () => {
      if (howWeHelpRef.current) {
        observer.unobserve(howWeHelpRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsHowWeWorkVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        root: null,
        rootMargin: "-100px",
        threshold: 0.2,
      }
    );

    if (howWeWorkRef.current) {
      observer.observe(howWeWorkRef.current);
    }

    return () => {
      if (howWeWorkRef.current) {
        observer.unobserve(howWeWorkRef.current);
      }
    };
  }, []);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const handleBookingClick = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };
  const handleConfirmBooking = () => {
    setIsPopupOpen(false);
  };

  return (
    <div className={styles.homePage}>
      <div className={styles.homepageBannerSection}></div>

      <div className={styles.loanWidgetAboutSection}>
        <h1 className={styles.homePageLoanTitle}>
          {t("Discover your perfect loan with no impact to your credit score!")}
        </h1>

        <div className={styles.loanWidgetAboutSectionWrapper}>
          {/* Repayment Widget */}
          <div className={styles.repaymentWidgetSection}>
            <div className={styles.selecteLoanWrapper}>
              <RepaymentWidget />
            </div>
          </div>

          {/* New row for image + content */}
          <div className={styles.aboutInfoRow}>
            {/* Image Section */}
            <div className={styles.aboutImageSection}>
              <Image
                className={styles.bannerAboutImage}
                src={aboutImage}
                alt="about-image"
                loading="eager"
                aria-hidden="false"
                role="img"
              />
            </div>

            {/* Content Section */}
            <div className={styles.aboutContentSection}>
              <div className={styles.bannerAboutContent}>
                <h1 className={styles.aboutTitle1}>
                  {t("A Proven Track Record")}
                </h1>
                <div
                  className={styles.trackRecordMatrixWrapper}
                  ref={aboutBannerRef}
                >
                  <div className={styles.trackRecordMatrixWrapper}>
                    <div className={styles.trackRecordMatrixItem}>
                      <h1 className={styles.trackRecordMatrixItemTitle}>
                        {happyClients}
                        <span className={styles.trackRecordMatrixItemPlus}>
                          +
                        </span>
                      </h1>
                      <p className={styles.trackRecordMatrixItemDescription}>
                        {t("Happy Clients")}
                      </p>
                    </div>
                    <div className={styles.trackRecordMatrixItem}>
                      <h1 className={styles.trackRecordMatrixItemTitle}>
                        {loanValue}
                        <span className={styles.trackRecordMatrixItemB}>B</span>
                        <span className={styles.trackRecordMatrixItemPlus}>
                          +
                        </span>
                      </h1>
                      <p className={styles.trackRecordMatrixItemDescription}>
                        {t("Loans Settled ($)")}
                      </p>
                    </div>
                  </div>
                </div>

                <div>
                  <h2 className={styles.aboutTitle}>
                    {t("Award-Winning Boutique Mortgage Brokerage")}
                  </h2>
                  {/* <p className={styles.bannerAboutDescription}>
              {t(
                "Your Key Choice Lending brokers are here to give you ultimate choice and flexibility. We help level the playing field to give you access to more than 40 lenders and insight into the bank's closely guarded policies."
              )}
            </p> */}
                </div>
                <div className={styles.bannerAwardsWrapper}>
                  <Image
                    src={awar1}
                    alt="awards-image"
                    loading="eager"
                    aria-hidden="false"
                    role="img"
                    height={100}
                    width={100}
                    className={styles.awards}
                  />
                  <Image
                    src={awar2}
                    alt="awards-image"
                    loading="eager"
                    aria-hidden="false"
                    role="img"
                    height={100}
                    width={100}
                    className={styles.awards}
                  />
                  <Image
                    src={awar3}
                    alt="awards-image"
                    loading="eager"
                    aria-hidden="false"
                    role="img"
                    height={100}
                    width={100}
                    className={styles.awards}
                  />
                </div>
                <div className={styles.bannerButtonsWrapper}>
                  <button
                    className={styles.bannerButton}
                    onClick={handleBookingClick}
                  >
                    <div className={styles.buttonIconWrapper}>
                      <Image
                        src={calendar}
                        alt="calendar icon"
                        width={20}
                        height={20}
                      />
                    </div>
                    <span>{t("Book a Meeting")}</span>
                  </button>

                  {/* <button className={styles.bannerButton}>
                    <div className={styles.buttonIconWrapper}>
                      <Image
                        src={ChatIcon}
                        alt="chat icon"
                        width={20}
                        height={20}
                      />
                    </div>
                    <span>{t("Chat with Human")}</span>
                  </button> */}
                  <button
                    className={styles.bannerButton}
                    onClick={() => window.toggleLiveChat?.()}
                  >
                    <div className={styles.buttonIconWrapper}>
                      <Image
                        src={ChatIcon}
                        alt="chat icon"
                        width={20}
                        height={20}
                      />
                    </div>
                    <span>{t("Chat with Human")}</span>
                  </button>
                </div>

                {/* Book Demo Popup */}
                <BookDemoPopup
                  isOpen={isPopupOpen}
                  onClose={handleClosePopup}
                  onConfirm={handleConfirmBooking}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.clientTestimonialSection}>
        <div className="container">
          <div className={styles.clientTestimonialSectionWrapper}>
            <div className={styles.clientTestimonialSectionContent}>
              <h2 className={styles.clientTestimonialSectionTitle}>
                {t("Our Clients Say It Best")}
              </h2>
              <p className={styles.clientTestimonialSectionDescription}>
                {t(
                  "We're proud of the service we provide and the solutions we deliver. Read our verified client reviews to find out what it's like to work with us"
                )}
              </p>
              <TestimonialCarousel />
            </div>
          </div>
        </div>
      </div>

      {renderLendersSection()}

      <div className={styles.howWeHelpSection} ref={howWeHelpRef}>
        <div className="container">
          <div className={styles.howWeHelpContent}>
            <h2
              className={`${styles.howWeHelpTitle} ${
                isHowWeHelpVisible ? styles.visible : ""
              }`}
            >
              {t("Your Lending Pathway")}
            </h2>
            <p
              className={`${styles.howWeHelpDescription} ${
                isHowWeHelpVisible ? styles.visible : ""
              }`}
            >
              {t(
                "We provide people across Melbourne with strategic guidance on all things finance. Whether you're wanting to invest in your business, release equity from your property portfolio, or are just starting out on the property ladder - we're here to make the process easier."
              )}
            </p>
            <div className={styles.howWeHelpCardWrapper}>
              <div className="col-12 col-lg-3 col-md-3 col-sm-3">
                <div
                  className={`${styles.howWeHelpCard} ${
                    isHowWeHelpVisible ? styles.visible : ""
                  }`}
                >
                  <Image
                    src={groupBlue}
                    alt="groupBlue"
                    loading="eager"
                    aria-hidden="false"
                    role="img"
                  />
                  <p className={styles.howWeHelpCardTitle}>
                    {t("Invest in my business")}
                  </p>
                  <p className={styles.howWeHelpCardDescription}>
                    {t(
                      "Expert guidance to help you grow and sustain your business"
                    )}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3 col-md-3 col-sm-3">
                <div
                  className={`${styles.howWeHelpCard} ${
                    isHowWeHelpVisible ? styles.visible : ""
                  }`}
                >
                  <Image
                    src={keyIconBlue}
                    alt="keyIconBlue"
                    loading="eager"
                    aria-hidden="false"
                    role="img"
                  />
                  <p className={styles.howWeHelpCardTitle}>{t("Buy a home")}</p>
                  <p className={styles.howWeHelpCardDescription}>
                    {t("We'll help you navigate the process")}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3 col-md-3 col-sm-3">
                <div
                  className={`${styles.howWeHelpCard} ${
                    isHowWeHelpVisible ? styles.visible : ""
                  }`}
                >
                  <Image
                    src={loopBlue}
                    alt="loopBlue"
                    loading="eager"
                    aria-hidden="false"
                    role="img"
                  />
                  <p className={styles.howWeHelpCardTitle}>
                    {t("Refinance my loans")}
                  </p>
                  <p className={styles.howWeHelpCardDescription}>
                    {t(
                      "We'll optimise your loans and secure you a better deal"
                    )}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3 col-md-3 col-sm-3">
                <div
                  className={`${styles.howWeHelpCard} ${
                    isHowWeHelpVisible ? styles.visible : ""
                  }`}
                >
                  <Image
                    src={building}
                    alt="building"
                    loading="eager"
                    aria-hidden="false"
                    role="img"
                  />
                  <p className={styles.howWeHelpCardTitle}>
                    {t("Invest in property")}
                  </p>
                  <p className={styles.howWeHelpCardDescription}>
                    {t("Latest insights to help you climb the property ladder")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.howWeWorkTogetherSection} ref={howWeWorkRef}>
        <div className="container">
          <div className={styles.howWeWorkContentWrapper}>
            <h2 className={styles.howWeWorkTitle}>
              {t("From Start to Settlement")}
            </h2>
            <p className={styles.howWeWorkDescription}>
              {t(
                "We take a systematic approach to helping you achieve a great outcome"
              )}
            </p>
            <div className={styles.howWeWorkCardWrapper}>
              <div className="col-12 col-lg-3 col-md-3 col-sm-3">
                <div
                  className={`${styles.howWeWorkCard} ${
                    isHowWeWorkVisible ? styles.visible : ""
                  }`}
                >
                  <div className={styles.imageContainer}>
                    <Image
                      src={circle1}
                      alt="home-loan-image"
                      loading="eager"
                      aria-hidden="false"
                      role="img"
                    />
                  </div>
                  <p className={styles.howWeWorkCardTitle}>{t("Discover")}</p>
                  <p className={styles.howWeWorkCardDescription}>
                    {t(
                      "We spend time with you to understand your goals and requirements"
                    )}
                  </p>
                </div>
              </div>
              <div
                className={`${styles.connectingLine} ${styles.line1} ${
                  isHowWeWorkVisible ? styles.visible : ""
                }`}
              ></div>
              <div className="col-12 col-lg-3 col-md-3 col-sm-3">
                <div
                  className={`${styles.howWeWorkCard} ${
                    isHowWeWorkVisible ? styles.visible : ""
                  }`}
                >
                  <div className={styles.imageContainer}>
                    <Image
                      className={styles.howWeWorkCardImage}
                      src={circle2}
                      alt="howWeWork"
                      loading="eager"
                      aria-hidden="false"
                      role="img"
                    />
                  </div>
                  <p className={styles.howWeWorkCardTitle}>{t("Analyse")}</p>
                  <p className={styles.howWeWorkCardDescription}>
                    {t(
                      "We analyse thousands of loan products to determine the right fit for you"
                    )}
                  </p>
                </div>
              </div>
              <div
                className={`${styles.connectingLine} ${styles.line2} ${
                  isHowWeWorkVisible ? styles.visible : ""
                }`}
              ></div>
              <div className="col-12 col-lg-3 col-md-3 col-sm-3">
                <div
                  className={`${styles.howWeWorkCard} ${
                    isHowWeWorkVisible ? styles.visible : ""
                  }`}
                >
                  <div className={styles.imageContainer}>
                    <Image
                      className={styles.howWeWorkCardImage}
                      src={circle3}
                      alt="howWeWork"
                      loading="eager"
                      aria-hidden="false"
                      role="img"
                    />
                  </div>
                  <p className={styles.howWeWorkCardTitle}>{t("Apply")}</p>
                  <p className={styles.howWeWorkCardDescription}>
                    {t(
                      "We making sure your application presents a strong case to the lender"
                    )}
                  </p>
                </div>
              </div>
              <div
                className={`${styles.connectingLine} ${styles.line3} ${
                  isHowWeWorkVisible ? styles.visible : ""
                }`}
              ></div>
              <div className="col-12 col-lg-3 col-md-3 col-sm-3">
                <div
                  className={`${styles.howWeWorkCard} ${
                    isHowWeWorkVisible ? styles.visible : ""
                  }`}
                >
                  <div className={styles.imageContainer}>
                    <Image
                      className={styles.howWeWorkCardImage}
                      src={circle4}
                      alt="howWeWork"
                      loading="eager"
                      aria-hidden="false"
                      role="img"
                    />
                  </div>
                  <p className={styles.howWeWorkCardTitle}>{t("Support")}</p>
                  <p className={styles.howWeWorkCardDescription}>
                    {t(
                      "We monitor the market to ensure you've always got the right solution"
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.ourBlogSection}>
        <div className="container">
          <div className={styles.ourBlogSectionWrapper}>
            <h2 className={styles.ourBlogSectionTitle}>
              {t("Browse our blog for property and finance insights")}
            </h2>
            <p className={styles.ourBlogSectionDescription}>
              {t("Stay up-to-date with the latest news and insights")}
            </p>
            <div className={styles.ourBlogSectionCardWrapper}>
              <div className="col-12 col-lg-4 col-md-4 col-sm-4">
                <div
                  className={styles.ourBlogSectionCard}
                  onClick={() =>
                    handleCardClick(
                      "/blogs/transform-your-retirement-with-home-equity-release/"
                    )
                  }
                >
                  <Image
                    className={styles.ourBlogSectionCardImage}
                    src={blogImage1}
                    alt="blog-image"
                    loading="eager"
                    aria-hidden="false"
                    role="img"
                  />
                  <div className={styles.ourBlogSectionCardContent}>
                    <p className={styles.ourBlogSectionCardTitle}>
                      {t("Transform Your Retirement with Home Equity Release")}
                    </p>
                    <div className={styles.readMoreWrapper}>
                      <p className={styles.readMoreText}>{t("Read more")}</p>
                      <Image
                        src={rightScrollArrow}
                        alt="right-scroll-arrow"
                        loading="eager"
                        height={5}
                        width={5}
                        aria-hidden="false"
                        role="img"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4 col-md-4 col-sm-4">
                <div
                  className={styles.ourBlogSectionCard}
                  onClick={() =>
                    handleCardClick(
                      "/blogs/demystifying-business-finance-jargon/"
                    )
                  }
                >
                  <Image
                    className={styles.ourBlogSectionCardImage}
                    src={blogImage1}
                    alt="blog-image"
                    loading="eager"
                    aria-hidden="false"
                    role="img"
                  />
                  <div className={styles.ourBlogSectionCardContent}>
                    <p className={styles.ourBlogSectionCardTitle}>
                      {t("Demystifying Business Finance Jargon")}
                    </p>
                    <div className={styles.readMoreWrapper}>
                      <p className={styles.readMoreText}>{t("Read more")}</p>
                      <Image
                        src={rightScrollArrow}
                        alt="right-scroll-arrow"
                        loading="eager"
                        height={5}
                        width={5}
                        aria-hidden="false"
                        role="img"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4 col-md-4 col-sm-4">
                <div
                  className={styles.ourBlogSectionCard}
                  onClick={() =>
                    handleCardClick(
                      "/blogs/comprehensive-loan-documentation-checklist/"
                    )
                  }
                >
                  <Image
                    className={styles.ourBlogSectionCardImage}
                    src={blogImage2}
                    alt="blog-image"
                    loading="eager"
                    aria-hidden="false"
                    role="img"
                  />
                  <div className={styles.ourBlogSectionCardContent}>
                    <p className={styles.ourBlogSectionCardTitle}>
                      {t("Comprehensive Loan Application Checklist")}
                    </p>
                    <div className={styles.readMoreWrapper}>
                      <p className={styles.readMoreText}>{t("Read more")}</p>
                      <Image
                        src={rightScrollArrow}
                        alt="right-scroll-arrow"
                        loading="eager"
                        height={5}
                        width={5}
                        aria-hidden="false"
                        role="img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ReachOutSection
        title={t("Ready to achieve your property goals?")}
        buttonText={t("Book a meeting")}
        buttonIcon={CalendarIconWhite}
      />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress size="15rem" color="inherit" />
      </Backdrop>
    </div>
  );
};
export default HomePage;
